import { type FC, useEffect } from 'react';

import { useToastStore } from 'dibs-toaster/exports/useToastStore.ts';
import { ADD_TO_FAVORITES_ACTION } from 'dibs-buyer-item-favoriting/exports/constants.ts';

import { useSbSharedFavoritesNudgeToast } from './useSbSharedFavoritesNudgeToast.tsx';
import { setFavoritesNudgeDisplayed } from '../helpers/setFavoritesNudgeDisplayed.ts';

type Props = {
    userId: string;
    onStopWatch: () => void;
};

const SbSharedFavoritesNudgeToastWatcher: FC<Props> = ({ userId, onStopWatch }) => {
    const lastToastAction = useToastStore(state => state.lastToastAction);
    const { isVisible } = useSbSharedFavoritesNudgeToast({ userId, showNudge: true });

    useEffect(() => {
        const isAddToFavoritesToastShown = lastToastAction === ADD_TO_FAVORITES_ACTION;
        if (isAddToFavoritesToastShown || isVisible) {
            if (isAddToFavoritesToastShown) {
                setFavoritesNudgeDisplayed();
            }

            onStopWatch();
        }
    }, [lastToastAction, isVisible, onStopWatch]);

    return null;
};

export { SbSharedFavoritesNudgeToastWatcher };
